import { useState } from 'react';
import { genreDetails } from '@/mocks/site';
import { movieList } from '@/mocks/movies';

export default function GenreSection() {
  const [active, setActive] = useState(0);
  const current = genreDetails[active];

  const related = movieList.filter((m) => m.genres.includes(current.name)).slice(0, 4);

  return (
    <section id="genres" className="scroll-mt-20 bg-background-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest text-accent-700 uppercase">
            <i className="ri-apps-2-line"></i> CATEGORIES
          </span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">按题材浏览影片</h2>
          <p className="mt-2 text-sm text-foreground-600">
            不同题材的资源在画质、音轨与字幕配置上各有侧重。选择下方标签，查看该题材的片源特点与代表性作品。
          </p>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {genreDetails.map((g, i) => (
            <button
              key={g.name}
              type="button"
              onClick={() => setActive(i)}
              className={`px-4 py-2 rounded-md text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                active === i
                  ? 'bg-secondary-500 text-background-50 border-secondary-500'
                  : 'bg-background-50 text-foreground-700 border-background-300 hover:border-secondary-300 hover:text-secondary-700'
              }`}
            >
              {g.name}
            </button>
          ))}
        </div>

        <div className="mt-6 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-3">
            <div className="lg:col-span-2 p-5 md:p-7">
              <div className="flex items-center gap-3">
                <span className="font-heading text-3xl font-bold text-primary-600">{current.name}</span>
                <span className="text-xs tracking-widest text-foreground-400 uppercase">{current.en}</span>
                <span className="ml-auto px-3 py-1 rounded-full bg-accent-100 text-accent-900 text-xs font-medium">
                  {current.count}
                </span>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-foreground-700">{current.intro}</p>

              <div className="mt-5 flex flex-wrap gap-2">
                {current.keywords.map((k) => (
                  <span key={k} className="px-3 py-1 rounded-full bg-background-100 border border-background-200 text-xs text-foreground-600">
                    {k}
                  </span>
                ))}
              </div>

              <div className="mt-6 p-4 rounded-lg bg-primary-50 border border-primary-100 flex items-start gap-3">
                <i className="ri-lightbulb-line text-primary-600 text-lg mt-0.5"></i>
                <p className="text-xs leading-relaxed text-primary-900">
                  <span className="font-semibold">选片提示：</span>{current.tip}
                </p>
              </div>
            </div>

            <div className="border-t lg:border-t-0 lg:border-l border-background-200 bg-background-100 p-5 md:p-6">
              <h3 className="text-sm font-semibold text-foreground-900 flex items-center gap-2">
                <i className="ri-star-smile-line text-accent-600"></i>
                代表性作品
              </h3>
              {related.length > 0 ? (
                <ul className="mt-4 flex flex-col gap-3">
                  {related.map((m) => (
                    <li key={m.id} className="flex items-center gap-3">
                      <img
                        src={m.poster}
                        alt={`${m.title} 海报`}
                        title={`${m.title} 高清下载`}
                        className="w-12 h-16 rounded object-cover border border-background-200 shrink-0"
                      />
                      <div className="min-w-0">
                        <p className="text-sm font-medium text-foreground-900 truncate">{m.title}</p>
                        <p className="text-xs text-foreground-500 mt-0.5 truncate">
                          {m.year} · {m.quality}
                        </p>
                        <p className="text-xs text-accent-700 mt-0.5 flex items-center gap-1">
                          <i className="ri-star-fill text-[10px]"></i>
                          {m.rating.toFixed(1)}
                        </p>
                      </div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="mt-4 text-xs text-foreground-500">该题材的代表作品将陆续补充。</p>
              )}
              <p className="mt-5 text-xs text-foreground-500 leading-relaxed border-t border-background-200 pt-4">
                点击顶部导航栏的「最新上线」，可按题材查看更多同类影片。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}